var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"progressbar"},_vm._l((_vm.length),function(i){return _c('li',{key:i,staticClass:"active"})}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }